<template>
  <highcharts
    v-if="timeseries.length > 0"
    ref="chart"
    class="chart"
    :options="processedSeries"
    :update-args="updateArgs"
  />
</template>

<script>
import {Chart} from 'highcharts-vue'
import moment from 'moment'

export default {
  name: 'Linegraph',
  components: {
    highcharts: Chart
  },
  props: [
    'timeseries',
    'datapointid',
    'loadingData',
  ],
  data() {
    return {
      updateArgs: [true,false,true],
      title: this.datapointid,
      options: {
        type: 'line',
        step: true
      }
    }
  },
  computed: {
    processedSeries: function(){
      if(this.timeseries.length > 0){
        return {
          credits: {
            enabled: false
          },
          chart: {
            type: this.options.type,
          },
          title: {
            text: 'Timeseries: ' + this.datapointid
          },
          time: {
            useUTC: false,
          },
          series: [{
            step: this.options.step,
            pointStart: moment(this.timeseries[0][0]).local().valueOf(),
            pointEnd: moment(this.timeseries[this.timeseries.length - 1][0]).local().valueOf(),
            data: this.timeseries.map(obs=>[moment(obs[0]).local().valueOf(),parseInt(obs[1])]),
            name: this.datapointid
          }],
          xAxis: {
            type: 'datetime'
          },
          yAxis: [{
            title: {
              text: null
            }
          }],
          responsive: {
            rules: [{
              condition: {
                maxWidth: 800
              },
            }]
          }
        }
      }else{
        return {}
      }
    }
  },
  watch: {
    loadingData(val) {
      if (this.$refs.chart) {
        if(val) {
          this.$refs.chart.chart.showLoading()
        } else {
          this.$refs.chart.chart.hideLoading()
        }
      }
    }
  },
  methods: {
    changeInterpolation: function(interpol){
      switch(interpol){
      case 'step':
        this.options.type = 'line'
        this.options.step = true
        break
      case 'line':
        this.options.type = 'line'
        this.options.step = false
        break
      case 'spline':
        this.options.type = 'spline'
        this.options.step = false
        break
      }
    },
  }
}
</script>

<style scoped>

</style>
